/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HomeRoutingModule } from './home-routing.module';

import { HomeComponent } from './home.component';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  declarations: [HomeComponent],
    imports: [CommonModule, HomeRoutingModule, MatButtonModule],
})
export class HomeModule {}
